/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-28 09:26:49
 * @LastEditors: linxi
 * @LastEditTime: 2021-09-09 11:29:22
 */

// 数据中心
export enum MenuTitle {
  // ProcessingData = "/datacenter/ProcessingData",
  FileData = "/datacenter/FileData",
  ExceptionListMessage = "/datacenter/ExceptionListMessage",
  OrganizationListMessage = "/datacenter/OrganizationListMessage",
}

export function getMenuTitleName(menuTitle: string) {
  switch (menuTitle) {
    // case "ProcessingData":
    //     return "执法数据"
    case "FileData":
      return "处置数据";
    case "ExceptionListMessage":
      return "预警数据";
    case "OrganizationListMessage":
      return "机构数据";
    default:
      return "处置数据";
  }
}

// 数据分析
export enum MenuTitles {
  pandect = "/statement/pandect",
  analyse = "/statement/analyse",
  proportion = "/statement/proportion",
  wpandect = "/statement/wpandect",
  wanalyse = "/statement/wanalyse",
  wcontrast = "/statement/wcontrast",
  wproportion = "/statement/wproportion",
  dataTreating = "/statement/dataTreating",
  wraningRuleProportion = "/statement/wraningRuleProportion",
  regulatoryData = "/statement/regulatoryData",
}

export function getSMenuTitleName(menuTitles: string) {
  switch (menuTitles) {
    case "pandect":
      return "监管数据总览";
    case "analyse":
      return "监管数据变化分析";
    case "proportion":
      return "监管数据占比分析";
    case "wpandect":
      return "监管数据总览";
    case "wanalyse":
      return "监管数据变化分析";
    case "wcontrast":
      return "监管数据对比分析";
    case "wproportion":
      return "监管数据占比分析";
    case "dataTreating":
      return "规则启用占比分析";
    case "wraningRuleProportion":
      return "规则预警占比分析";
    case "regulatoryData":
      return "规则执法占比分析";
    default:
      return "监管数据总览";
  }
}

// 系统管理
export enum MenuTitled {
  accountStation = "/system/accountStation",
  factory = "/system/factory",
  warningrules = "/system/warningrules",
}

export function getMenuTitleNamed(menuTitled: string) {
  switch (menuTitled) {
    case "accountStation":
      return "账号管理";
    case "factory":
      return "卫健委(局)管理";
    case "warningrules":
      return "预警规则";
    default:
      return "卫健委(局)管理";
  }
}
